import { Box, stepConnectorClasses, stepperClasses, styled } from '@mui/material'
import { ParcelTape, Truck, ServicePoint, StackedParcels, Customs, LabelPrinter, ShopPayment } from '@dhl/illustrations'
import { Stepper as StepperComponent } from '@dhl/components'
import { StepNavigation } from '~/basket/view/withBasket'

const DhlStepper = styled(StepperComponent)(({ theme: { breakpoints, spacing } }) => ({
  [`&.${stepperClasses.root}`]: {
    [breakpoints.down('xl')]: {
      marginLeft: spacing(-6),
      marginRight: spacing(-6),
    },
    [breakpoints.down('md')]: {
      marginLeft: spacing(-10),
      marginRight: spacing(-10),
    },
    [breakpoints.down('sm')]: {
      marginLeft: spacing(-2),
      marginRight: spacing(-2),
    },
  },
}))

const StyledParcelTape = styled(ParcelTape)(({ theme }) => ({
  transform: 'scale(75%)',

  [theme.breakpoints.between('sm', 'md')]: {
    marginLeft: theme.spacing(2),
  },
}))

const StyledStepper = styled(DhlStepper)(({ theme }) => ({
  [`& .${stepConnectorClasses.alternativeLabel}`]: {
    [theme.breakpoints.between('sm', 'md')]: {
      top: 'calc(50% + 7px)',
    },
  },
}))

const getIcon = (step: string) => {
  switch (step) {
    case 'package':
      return StyledParcelTape
    case 'receiver':
      return Truck
    case 'shipper':
      return ServicePoint
    case 'overview':
      return StackedParcels
    case 'customs':
      return Customs
    case 'label':
      return LabelPrinter
    case 'payment':
      return ShopPayment
    default:
      throw new Error(`Unknown illustration: ${step}`)
  }
}

type Props = {
  stepNavigation: StepNavigation
}

export const Stepper = ({ stepNavigation }: Props) => {
  const steps = stepNavigation.previousSteps.concat([stepNavigation.displayedStep]).concat(stepNavigation.nextSteps)

  const stepsWithIcons = steps.map((step) => ({
    key: step,
    icon: getIcon(step),
  }))

  const activeStep = steps.indexOf(stepNavigation.displayedStep)

  return (
    <Box px={2}>
      <StyledStepper activeStep={activeStep} steps={stepsWithIcons} />
    </Box>
  )
}
